<template>
    <div class="BEwrapper" style="background: white">
        <div class="menu">
            <router-link to="/backend/naviconfig">Nodes Config</router-link>
            <router-link to="/backend/navitest">Shop Data</router-link>
            <router-link to="/backend/localconfig">Local Config</router-link>
            <router-link to="/backend/werbung">Werbung</router-link>
<!--            <router-link to="/backend/startdesc">Start Descriptions</router-link>-->
            <router-link to="/">to Frontend</router-link>
        </div>
        <router-view :store="store" :location="location" :options="options" :jsondata="jsondata"></router-view>
    </div>
</template>
<script>
    import Toolbar from '@/components/Toolbar.vue'
    import router from '@/router'
    import * as language from '@/translations'

    export default {
        name: 'Backend',
        data() {
            return {
                timestring: '',
                datestring: '',
                locations: [
                    {id: 1, house: 1, level: 2},
                    {id: 2, house: 3, level: 1}
                ],
                location: {
                    house: 1, level: 2
                },
                language: language,
                currentLanguage: 'ENGLISH',
                isLangDropOpen: false,
            }
        },
        components: {
            Toolbar
        },
        props: ['store', 'options', 'jsondata'],
        created() {
            this.setDate()
            let url = new URL(window.location.href);
            let location = url.searchParams.get('location');
            if ( location ){
                this.location = this.locations.find(x=> x.id == location);
            }
        },
        mounted() {
            document.getElementById('app').addEventListener('click', function () {
                resetTimer();
            });
            window.theTimer = setTimeout(function () {
                reset()
            }, 5000)
            function resetTimer() {
                clearTimeout(window.theTimer);
                window.theTimer = setTimeout(function () {
                    reset()
                }, 30000)
            }
            function reset() {
                router
            }
        },
        computed: {
            getHouseColor(){
                return this.store.houseColors.find(x=> x.id == this.location.house).color
            },
            otherLanguages(){
                return this.language.languages.filter(x=> x.name != this.currentLanguage)
            },
            languageStrings(){
                return this.language.strings[this.currentLanguage];
            }
        },
        methods: {
            setDate(){
                var now = new Date();
                var datestring = now.toLocaleDateString('de-DE', {weekday: 'short'}) + ', ' + now.toLocaleDateString('de-DE', {day: 'numeric'}) + '. ' + now.toLocaleDateString('de-DE', {month: 'long'});
                this.datestring = datestring;
                var mins = now.getMinutes();
                var timestring = now.getHours() + ':' + (mins > 9 ? mins : '0' + mins);
                this.timestring = timestring;
            },
            startTimer(){

            },
            setLanguage(lang){
                this.currentLanguage = lang;
                this.isLangDropOpen = false;
            }
        }

    }

</script>

<style lang="scss" scoped>

    @import "@/styles/variables";

    body {
        background: white;
    }

    .BEwrapper {
        padding: 50px;
        min-height: 100vh;
    }

    .menu {
        padding: 10px 30px;
        background: $blue;
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;

        a {
            margin-right: 20px;
            color: white;
        }

    }


</style>